import Cache from '../utils/Cache';

export default class Checklist {
  constructor(element) {
    this.element = element;
    this.id = this.element.dataset.id;
    this.checks = this.element.querySelectorAll('.js-check');
    if (this.checks.length) {
      this.restoreStatus();
    } else {
      this.count();
    }
    this.init();

    // save
    const btnSave = document.querySelector('.js-save');
    if (btnSave) {
      btnSave.addEventListener('click', this.initSave.bind(this));
    }

    // toggle
    this.initStepsToggle();

    // checkState
    this.checkState();
  }

  init() {
    for (let i = 0; i < this.checks.length; i++) {
      const check = this.checks[i];
      check.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(e) {
    const name = e.currentTarget.name;
    const isChecked = e.currentTarget.checked;
    Cache.set(name, isChecked, true);
  }

  count() {
    const countEl = this.element.querySelector('.js-count');
    const total = Cache.get(`${this.id}-total`);

    if (countEl && total) {
      let completed = 0;
      for (let i = 0; i < total; i++) {
        if (Cache.get(`${this.id}_${i}`) === 'true') {
          completed += 1;
        }
      }
      countEl.innerHTML = `${completed}/${total}`;
    }
  }

  restoreStatus() {
    Cache.set(`${this.id}-total`, this.checks.length, true);

    for (let i = 0; i < this.checks.length; i++) {
      const check = this.checks[i];
      if (Cache.get(check.name) === 'true') {
        check.checked = true;
      }
    }
  }

  checkState() {
    const url = document.location.href.split('?');
    const host = url[0];
    const params = url[1];

    if (params) {
      const searchParams = new URLSearchParams(params).get('p');
      if (searchParams) {
        for (let i = 0; i < searchParams.length; i++) {
          const name = this.checks[i].name;
          const isChecked = searchParams[i] == 1 ? true : false;
          Cache.set(name, isChecked, true);
        }

        const cleanedURL = new URLSearchParams(params).delete('p');
        document.location.href = host;
        this.restoreStatus();
      }
    }
  }

  initSave() {
    const state = [];
    for (let i = 0; i < this.checks.length; i++) {
      const check = this.checks[i];
      const value = Cache.get(check.name) === 'true' ? 1 : 0;
      state.push(value);
    }

    const pageUrl = '?p=' + state.join('');
    window.history.pushState('', '', pageUrl);
  }

  initStepsToggle() {
    this.currentSteps = 0;
    this.elSections = this.element.querySelectorAll('.js-section');
    if (!this.elSections.length) return false;

    this.elPagination = document.querySelector('.js-steps-page');
    this.stepsState = false;

    const btnToggle = document.querySelector('.js-steps-toggle');
    if (btnToggle) {
      btnToggle.addEventListener('click', this.toggleSteps.bind(this));
    }

    // prev
    this.btnPrev = document.querySelector('.js-steps-prev');
    if (this.btnPrev) {
      this.btnPrev.addEventListener('click', this.prevStep.bind(this));
    }
    document.addEventListener('keydown', (e) => {
      if (e.code == 'ArrowRight') {
        this.updateStep(1);
      } else if (e.code == 'ArrowLeft') {
        this.updateStep(-1);
      }
    });

    // next
    this.btnNext = document.querySelector('.js-steps-next');
    if (this.btnNext) {
      this.btnNext.addEventListener('click', this.nextStep.bind(this));
    }

    this.updateStep();

    // Cache
    if (Cache.get('collapsed') === 'true') {
      this.toggleSteps(true);
    }
  }

  toggleSteps() {
    this.stepsState = !this.stepsState;
    document.documentElement.dataset.steps = this.stepsState;

    Cache.set('collapsed', this.stepsState, true);
  }

  nextStep() {
    this.updateStep(1);
  }

  prevStep() {
    this.updateStep(-1);
  }

  updateStep(direction) {
    if (!isNaN(direction)) {
      this.currentSteps = Math.max(
        0,
        Math.min(this.currentSteps + direction, this.elSections.length - 1)
      );
    }

    if (this.currentSteps < 1) {
      this.btnPrev.classList.add('is-disabled');
    } else {
      this.btnPrev.classList.remove('is-disabled');
    }

    if (this.currentSteps >= this.elSections.length - 1) {
      this.btnNext.classList.add('is-disabled');
    } else {
      this.btnNext.classList.remove('is-disabled');
    }

    for (let i = 0; i < this.elSections.length; i++) {
      const section = this.elSections[i];
      section.classList.remove('is-collapsed');
    }
    this.elSections[this.currentSteps].classList.add('is-collapsed');

    // Pagination
    this.elPagination.innerText = `${this.currentSteps + 1} / ${
      this.elSections.length
    }`;
  }
}
